export const MEDIA_MANAGER_ROLE = 8;

export function homeForRole(role) {
  switch (Number(role)) {
    case 1:
    case 3:
      return '/admin';
    case 2:
      return '/manager';
    case MEDIA_MANAGER_ROLE:
      return '/media';
    default:
      return '/home';
  }
}

export function canAccessRoute(role, allowedRoles) {
  const value = Number(role);
  return allowedRoles ? allowedRoles.includes(value) : value !== MEDIA_MANAGER_ROLE;
}
